import React, { ReactNode, useState } from 'react';

import { PaymentGroup } from 'models/paymentCard';

import { AggregateContainer, Group } from './styles';

interface Props {
  groups: PaymentGroup[];
  children: ReactNode;
}

const AggregateGroups = ({ groups, children }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <AggregateContainer>
      {children}
      {groups.length > 0 ? (
        isOpen ? (
          groups.map((g: PaymentGroup, idx) => (
            <Group
              key={idx}
              onClick={() => {
                if (idx === 0) {
                  setIsOpen(false);
                }
              }}
            >
              <Group.Icon src="/corporate/images/payment/group.svg" alt="" />
              <Group.Title>{g.name}</Group.Title>
              {idx === 0 ? <Group.ArrowUpIcon /> : null}
            </Group>
          ))
        ) : (
          <Group
            onClick={() => {
              if (groups.length > 2) {
                setIsOpen(true);
              }
            }}
          >
            <Group.Icon src="/corporate/images/payment/group.svg" alt="" />
            <Group.Title>
              {groups
                .slice(0, 2)
                .map((i) => i.name)
                .join(', ')}{' '}
              {groups.length > 2 ? `, +${groups?.length - 2}` : null}
            </Group.Title>
            {groups.length > 2 ? <Group.ArrowDownIcon /> : null}
          </Group>
        )
      ) : null}
    </AggregateContainer>
  );
};

export default AggregateGroups;
